import i18n from "i18next";

import { Colors } from "@/constants/colors";

const enum BgKeys {
    zing_prod_feb24_bg_1 = "zing_prod_feb24_bg_1",
    zing_prod_feb24_bg_2 = "zing_prod_feb24_bg_2",
    zing_prod_feb24_bg_3 = "zing_prod_feb24_bg_3",
    zing_prod_feb24_bg_4 = "zing_prod_feb24_bg_4",
    zing_prod_feb24_bg_5 = "zing_prod_feb24_bg_5",
    zing_prod_feb24_bg_6 = "zing_prod_feb24_bg_6",
}

export const backgroundImgs = {
    zing_prod_feb24_bg_1: "bg-femaleTestLoaderPromo1",
    zing_prod_feb24_bg_2: "bg-femaleTestLoaderPromo2",
    zing_prod_feb24_bg_3: "bg-femaleTestLoaderPromo3",
    zing_prod_feb24_bg_4: "bg-femaleTestLoaderPromo4",
    zing_prod_feb24_bg_5: "bg-femaleTestLoaderPromo5",
    zing_prod_feb24_bg_6: "bg-femaleTestLoaderPromo6",
};

export const titles = {
    zing_prod_feb24_title_1: "See How Fast You Can\nHit Your Fitness Goals\nwith Zing",
    zing_prod_feb24_title_2: "Female-Focused\nFitness",
    zing_prod_feb24_title_3: "Discover a 28-day transformation with a fitness program",
    zing_prod_feb24_title_4: "Become the most confident person in the room",
    zing_prod_feb24_title_5: "Become Your Best Self, Girl",
    zing_prod_feb24_title_6: "Hey Beautiful, Your Transformation Awaits",
};

export const subtitles = {
    zing_prod_feb24_subtitle_1: "Get a new you in 12 weeks",
    zing_prod_feb24_subtitle_2: "Lose weight with AI-powered workouts plans. Take the quiz now!",
    zing_prod_feb24_subtitle_3:
        "Connect with the training support that empowers women like you to achieve fitness success.",
    zing_prod_feb24_subtitle_4: "Lose Weight with Zing Coach’s Workouts. Take the quiz now!",
    zing_prod_feb24_subtitle_5: "Discover a fitter you in a few sessions with your AI coach",
    zing_prod_feb24_subtitle_6:
        "Zing Coach combines research, tech, and user feedback to help you burn fat and get fit.",
};

// styles
export const varinatsStyles = {
    [BgKeys.zing_prod_feb24_bg_1]: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-end",
    },
    [BgKeys.zing_prod_feb24_bg_2]: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-end",
    },
    [BgKeys.zing_prod_feb24_bg_3]: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-end",
    },
    [BgKeys.zing_prod_feb24_bg_4]: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-end",
    },
    [BgKeys.zing_prod_feb24_bg_5]: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-end",
    },
    [BgKeys.zing_prod_feb24_bg_6]: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-end",
    },
    maleDefault: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-between",
    },
    femaleDefault: {
        logoColor: Colors.WHITE,
        textColor: "text-white",
        contentStyle: "justify-between",
    },
};

// control values
export const femaleDefaultCombination = {
    backgroundImg: "bg-femaleLoaderPromo",
    title: i18n.t("zing_promotion"),
    subtitle: i18n.t("12_weeks_goal"),
    styles: varinatsStyles.femaleDefault,
};

export const maleDefaultCombination = {
    backgroundImg: "bg-loaderPromo",
    title: i18n.t("zing_promotion"),
    subtitle: i18n.t("12_weeks_goal"),
    styles: varinatsStyles.maleDefault,
};
